export default __webpack_public_path__ + "static/desserto-sand-50fe0d757b732c65f245179d83e38760.png";